"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderPlaceholdersToNodes = exports.renderPlaceholdersToNodes = exports.extractSimplePlaceholders = exports.useTranslations = exports.useGlotstack = exports.GlotstackProvider = exports.access = exports.setLogLevel = exports.LogLevel = exports.GlotstackContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const object_1 = require("./util/object");
exports.GlotstackContext = React.createContext({
    translations: {},
    loadTranslations: () => { throw new Error('no import method set'); },
    setLocale: (_locale) => { throw new Error('import method not set'); },
    locale: null,
    importMethod: (_locale) => { throw new Error('import method not set'); },
    t: () => { throw new Error('import method not set'); },
    ssr: false
});
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["LOG"] = 1] = "LOG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARNING"] = 3] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
const LogLevelToFunc = {
    [LogLevel.DEBUG]: console.debug,
    [LogLevel.INFO]: console.info,
    [LogLevel.LOG]: console.log,
    [LogLevel.WARNING]: console.warn,
    [LogLevel.ERROR]: console.error,
};
let logLevel = LogLevel.DEBUG;
const setLogLevel = (level) => {
    logLevel = level;
};
exports.setLogLevel = setLogLevel;
const makeLoggingFunction = (level) => (...args) => {
    const func = LogLevelToFunc[level];
    if (level < logLevel) {
        return;
    }
    return func(`[level=${level} logLevel=${logLevel}][glotstack.ai]`, ...args);
};
const logger = {
    debug: makeLoggingFunction(LogLevel.DEBUG),
    info: makeLoggingFunction(LogLevel.INFO),
    warn: makeLoggingFunction(LogLevel.WARNING),
    error: makeLoggingFunction(LogLevel.ERROR),
};
const access = (key, locale, translations) => {
    var _a;
    if (translations == null) {
        return key;
    }
    const access = [...key.split('.')];
    const localeTranslations = translations === null || translations === void 0 ? void 0 : translations[locale];
    if (localeTranslations == null) {
        return key;
    }
    const value = access.reduce((acc, key) => {
        // @ts-expect-error expected
        return acc === null || acc === void 0 ? void 0 : acc[key];
    }, localeTranslations);
    return ((_a = value === null || value === void 0 ? void 0 : value.value) !== null && _a !== void 0 ? _a : key);
};
exports.access = access;
const GlotstackProvider = ({ children, initialLocale, initialTranslations, onLocaleChange, onTranslationLoaded, importMethod, ssr }) => {
    if (initialLocale == null) {
        throw new Error('initialLocale must be set');
    }
    const [locale, setLocale] = React.useState(initialLocale);
    const translationsRef = React.useRef(initialTranslations || null);
    const loadingRef = React.useRef({});
    const loadTranslations = React.useCallback((locale, opts) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        // TODO: if translations are loaded only reload if some condition is
        try {
            if (((_a = loadingRef.current) === null || _a === void 0 ? void 0 : _a[locale]) != null && (opts === null || opts === void 0 ? void 0 : opts.force) != true) {
                logger.debug('Waiting for translations already loading', locale);
                return (yield ((_b = loadingRef.current) === null || _b === void 0 ? void 0 : _b[locale]));
            }
            if (((_c = translationsRef.current) === null || _c === void 0 ? void 0 : _c[locale]) != null && (opts === null || opts === void 0 ? void 0 : opts.force) != true) {
                logger.debug('Skipping load for translations', locale, (_d = translationsRef.current) === null || _d === void 0 ? void 0 : _d[locale], translationsRef.current);
                return (_e = translationsRef.current) === null || _e === void 0 ? void 0 : _e[locale];
            }
            if (loadingRef.current != null) {
                logger.debug('Loading translations', locale, (0, object_1.merge)({}, (_f = translationsRef.current) !== null && _f !== void 0 ? _f : {}));
                loadingRef.current[locale] = importMethod(locale);
            }
            const result = yield loadingRef.current[locale];
            if (result == null) {
                throw new Error(`Failed to load translation ${locale} ${JSON.stringify(result)}`);
            }
            if (translationsRef.current) {
                translationsRef.current[locale] = result;
            }
            onTranslationLoaded === null || onTranslationLoaded === void 0 ? void 0 : onTranslationLoaded(locale, result);
            return result;
        }
        catch (err) {
            logger.error('Unable to import translations', err);
            throw err;
        }
    }), [importMethod, onTranslationLoaded]);
    React.useEffect(() => {
        const run = () => __awaiter(void 0, void 0, void 0, function* () {
            onLocaleChange === null || onLocaleChange === void 0 ? void 0 : onLocaleChange(locale);
            yield loadTranslations(locale);
        });
        React.startTransition(() => {
            run();
        });
    }, [locale]);
    const context = React.useMemo(() => {
        var _a;
        return {
            setLocale,
            translations: (_a = translationsRef.current) !== null && _a !== void 0 ? _a : {},
            locale,
            importMethod,
            loadTranslations,
            t: (key, opts) => {
                var _a, _b, _c;
                const resolvedLocale = (_a = opts === null || opts === void 0 ? void 0 : opts.locale) !== null && _a !== void 0 ? _a : locale;
                loadTranslations(resolvedLocale);
                return (0, exports.access)(key, (_b = opts === null || opts === void 0 ? void 0 : opts.locale) !== null && _b !== void 0 ? _b : locale, (_c = translationsRef.current) !== null && _c !== void 0 ? _c : {});
            },
            ssr: ssr == true,
        };
    }, [locale, importMethod]);
    return (0, jsx_runtime_1.jsx)(exports.GlotstackContext.Provider, { value: context, children: children });
};
exports.GlotstackProvider = GlotstackProvider;
const useGlotstack = () => {
    return React.useContext(exports.GlotstackContext);
};
exports.useGlotstack = useGlotstack;
const useTranslations = (_options) => {
    const context = React.useContext(exports.GlotstackContext);
    return context;
};
exports.useTranslations = useTranslations;
const curlyRegex = /(?<!\\)({{\s*([a-zA-Z0-9_]+)\s*(?:,\s*([^{}]*?))?\s*}})/g;
const componentRegex = /<([A-Z][a-zA-Z0-9]*)>([\s\S]*?)<\/\1>/g;
function extractSimplePlaceholders(input) {
    var _a, _b;
    const results = [];
    for (const match of input.matchAll(curlyRegex)) {
        const raw = match[1];
        const key = match[2];
        const rawOptions = match[3];
        const index = (_a = match.index) !== null && _a !== void 0 ? _a : -1;
        const options = rawOptions
            ? rawOptions.split(',').map(opt => opt.trim()).filter(Boolean)
            : [];
        results.push({ key, options, raw, index, kind: 'doubleCurly' });
    }
    for (const match of input.matchAll(componentRegex)) {
        const raw = match[0];
        const key = match[1];
        const index = (_b = match.index) !== null && _b !== void 0 ? _b : -1;
        results.push({ key, options: [], raw, index, kind: 'component' });
    }
    return results.sort((a, b) => a.index - b.index);
}
exports.extractSimplePlaceholders = extractSimplePlaceholders;
function renderPlaceholdersToNodes(input, placeholders, assigns) {
    const nodes = [];
    let cursor = 0;
    for (const { index, raw, key, kind } of placeholders) {
        if (cursor < index) {
            nodes.push(input.slice(cursor, index));
        }
        let value = raw;
        if (kind === 'component') {
            const Render = assigns[key];
            const inner = raw.replace(new RegExp(`^<${key}>`), '').replace(new RegExp(`</${key}>$`), '');
            if (React.isValidElement(Render)) {
                value = React.cloneElement(Render, {}, inner);
            }
            else if (typeof Render === 'function') {
                value = (0, jsx_runtime_1.jsx)(Render, { children: inner });
            }
            else {
                logger.warn(`Invalid assign substitution for:\n\n  ${raw}\n\nDid you remember to pass assigns?\n`, `
t('key', { assigns: {
  ${key}: <something />  // children will be copied via React.cloneElement
}})\nor\n
t('key', { assigns: {
  ${key}: MyComponent  // component will be rendered with <Component/>
}})\n
`);
            }
        }
        else if (kind === 'doubleCurly') {
            const Render = assigns[key];
            value = typeof Render !== 'function' ? Render : raw !== null && raw !== void 0 ? raw : raw;
        }
        nodes.push(value);
        cursor = index + raw.length;
    }
    if (cursor < input.length) {
        nodes.push(input.slice(cursor));
    }
    // Unescape \{{...}} to {{...}}, and wrap ReactNodes
    return nodes.map((node, i) => typeof node === 'string'
        ? node.replace(/\\({{[^{}]+}})/g, '$1')
        : (0, jsx_runtime_1.jsx)(React.Fragment, { children: node }, i));
}
exports.renderPlaceholdersToNodes = renderPlaceholdersToNodes;
function useRenderPlaceholdersToNodes(...args) {
    const nodes = React.useMemo(() => renderPlaceholdersToNodes(...args), [...args]);
    return nodes;
}
exports.useRenderPlaceholdersToNodes = useRenderPlaceholdersToNodes;
//# sourceMappingURL=index.js.map